import { render, staticRenderFns } from "./icon-jpeg.vue?vue&type=template&id=603c70ea&"
import script from "./icon-jpeg.vue?vue&type=script&lang=js&"
export * from "./icon-jpeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports